export default function mergeObject(source: Record<string, any>, update: Record<string, any>) {
   return Object.keys({ ...source, ...update }).reduce(
      (acc, key) => Object.assign(acc, { [key]: update[key] || source[key] }),
      {}
   )
}
